import $ from 'jquery';
import ApplicationController from './application_controller';

/**
 * Drives the "Apply credit" modal rendered by
 * app/views/patient_invoices/_apply_credit.html.erb (attached to the modal
 * element itself). Clicking an .apply-credit-btn anywhere on the page fills
 * the modal from the button's data attributes, fetches the credit
 * application preview, and shows the modal.
 *
 * The buttons live in invoice tables that can be re-rendered independently
 * of this modal, so the click handler is delegated from `document` — but it
 * is bound in connect() and removed in disconnect(). The previous inline
 * turbo:load script stacked a new document-level handler on every Turbo
 * visit (the partial is rendered on both the patient payments page and the
 * patient invoices index, which users bounce between), firing N duplicate
 * preview requests per click after N visits.
 */
export default class extends ApplicationController {
  connect() {
    this.onClick = (event) => this.open($(event.currentTarget));
    $(document).on('click', '.apply-credit-btn', this.onClick);
  }

  disconnect() {
    $(document).off('click', '.apply-credit-btn', this.onClick);
  }

  open(button) {
    // Read per-record values from the button's data attributes at click time
    const invoiceId = button.data('invoice-id');
    const modal = $(this.element);

    modal.find('#sourceInvoiceNumber').text(button.data('invoice-number'));
    modal.find('#creditAmount').text(button.data('credit'));
    modal.find('#applyCreditForm').attr('action', `/patient-invoices/${invoiceId}/apply-credit`);

    // Reset container to show spinner
    modal
      .find('#targetInvoicesContainer')
      .html(
        '<div class="text-center py-3"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>'
      );

    // Fetch preview data
    $.ajax({
      url: `/patient-invoices/${invoiceId}/preview-credit-application`,
      method: 'GET',
      success: (data) => {
        modal.find('#targetInvoicesContainer').html(this.previewHtml(data));
      },
      error: () => {
        modal
          .find('#targetInvoicesContainer')
          .html('<div class="alert alert-danger">Error loading invoice preview. Please try again.</div>');
      },
    });

    // Show the modal
    modal.modal('show');
  }

  previewHtml(data) {
    let html = '<div class="table-responsive"><table class="table table-sm">';
    html +=
      '<thead><tr><th>Invoice #</th><th>Date</th><th class="text-right">Current balance</th><th class="text-right">Amount to apply</th><th class="text-right">New balance</th></tr></thead><tbody>';

    data.target_invoices.forEach((invoice) => {
      html += `<tr>
        <td>${invoice.invoice_number}</td>
        <td>${invoice.invoice_date}</td>
        <td class="text-right">${invoice.remaining_balance}</td>
        <td class="text-right"><strong>${invoice.amount_to_apply}</strong></td>
        <td class="text-right">${invoice.new_balance}</td>
      </tr>`;
    });

    html += '</tbody></table></div>';

    if (data.remaining_credit) {
      html += `<p>Remaining credit after application: <strong>${data.remaining_credit}</strong></p>`;
    }

    return html;
  }
}
